import Styled from 'styled-components';

import { UnorderedList } from './List';

export const ListBullet = Styled(UnorderedList)`
  list-style: none;
  color: ${({ theme: { text } }) => text.colorText};
`;

ListBullet.displayName = 'ListBullet';
